import { render, staticRenderFns } from "./imgUploader.vue?vue&type=template&id=0430d90a"
import script from "./imgUploader.vue?vue&type=script&lang=js"
export * from "./imgUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports